<template>
    <v-dialog v-model="dialog" persistent width="500px">
        <v-card>
            <v-card-title class="info headline" style="font-weight:bold; color:white">(Re)send confirmation mail</v-card-title>
            <br>
            <v-card-text>
                <p>A confirmation mail will be (re)sent to</p>                
                <div v-if="hocts.length !== 0" style="font-weight: 800 !important;">
                    <tr v-for="(contact, index) in hocts" :key="index">
                        <td class="pr-3">{{ contact.name }}</td>
                        <td class="pr-3">{{ contact.email }}</td>                    
                    </tr>
                </div>
                <div v-else>
                    (no recipients)
                </div>                
                <br><p>Please confirm this action.</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small v-on:click="processQuestion('yes')">Yes</v-btn>
                <v-btn color="success" small @click="processQuestion('no')">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
   export default {
        watch:{
            hpbz_encrid: {            
                handler(){
                    this.getHoctRecords();
                } 
            },
        }, 
        props: {
            hpbz_encrid: {
                type: String,
                default: ''
            },      
        },    
        data() {
            return {
                dialog: false,
                hocts: [],
            }
        },
        methods: {
            open() {
                this.dialog = true;
            },
            getHoctRecords() {
                this.$axios
                    .post("ares/json/ares/hpbz/getHpbzHoct.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHpbzHoct"
                        },
                        getHpbzHoct: {
                            hpbz_encrid: this.hpbz_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error.message);
                        } else {
                            this.hocts = res.data.getHpbzHoct;
                        }
                    })
            },               
            processQuestion(answer){
                this.$emit('processQuestion', answer);
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>